import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { BarTitle } from "../components/CollapseBar";
import { Truck, Plus, Trash2, Save } from "lucide-react";
import { ARAC_TIPLERI, HIZMETLER, yakitTahmin } from "../lib/vehicles";

const EMPTY = { marka: "", model: "", cekici_plaka: "", dorse_plaka: "", surucu: "", surucu_tel: "", arac_tipi: "TIR", hizmet: "ANA HAT", yakit_100km: "", aciklama: "" };
const COLS = [["marka", "MARKA"], ["model", "MODEL"], ["cekici_plaka", "ÇEKİCİ PLAKA"], ["dorse_plaka", "DORSE PLAKA"], ["surucu", "SÜRÜCÜ"], ["surucu_tel", "SÜRÜCÜ TEL"], ["arac_tipi", "ARAÇ TİPİ"], ["hizmet", "HİZMET"], ["yakit_100km", "YAKIT lt/100km"], ["aciklama", "AÇIKLAMA"]];
const inp = "h-8 w-full rounded border border-slate-700 bg-slate-800 px-2 text-xs text-slate-100";

function Cell({ k, v, on }) {
  if (k === "arac_tipi") return <select value={v || "TIR"} onChange={(e) => on(e.target.value)} className={inp}>{ARAC_TIPLERI.map((a) => <option key={a}>{a}</option>)}</select>;
  if (k === "hizmet") return <select value={v || "ANA HAT"} onChange={(e) => on(e.target.value)} className={inp}>{HIZMETLER.map((a) => <option key={a}>{a}</option>)}</select>;
  return <input value={v || ""} onChange={(e) => on(e.target.value.toLocaleUpperCase("tr-TR"))} className={inp} />;
}

export default function Vehicles() {
  const [rows, setRows] = useState([]);
  const [f, setF] = useState(EMPTY);
  const [dirty, setDirty] = useState({});
  const load = () => api.get("/vehicles").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);
  const withFuel = (o) => ({ ...o, yakit_100km: o.yakit_100km || String(yakitTahmin(o.marka, o.model, o.arac_tipi)) });
  const add = async () => {
    if (!f.cekici_plaka.trim()) { toast.error("ÇEKİCİ PLAKA GEREKLİ"); return; }
    await api.post("/vehicles", { data: withFuel(f) }); toast.success("ARAÇ KAYDEDİLDİ"); setF(EMPTY); load();
  };
  const upd = (id, k, v) => { setRows((a) => a.map((r) => (r.id === id ? { ...r, [k]: v } : r))); setDirty((d) => ({ ...d, [id]: true })); };
  const save = async (r) => { await api.put(`/vehicles/${r.id}`, { data: r }); setDirty((d) => ({ ...d, [r.id]: false })); toast.success("GÜNCELLENDİ"); };
  const del = async (id) => { if (!window.confirm("ARAÇ SİLİNSİN Mİ?")) return; await api.delete(`/vehicles/${id}`); load(); };
  return (
    <div className="mw-fade-up space-y-3" data-testid="vehicles-page">
      <BarTitle><div>
        <h1 className="font-head flex items-center gap-2 text-3xl font-bold tracking-tight text-white"><Truck className="h-7 w-7 text-sky-400" /> ARAÇ LİSTESİ</h1>
        <p className="text-sm text-slate-400">{rows.length} ARAÇ</p>
      </div></BarTitle>
      <div data-testid="vehicle-add-row" className="grid grid-cols-2 gap-2 rounded-xl border border-slate-800 bg-slate-900 p-3 md:grid-cols-6 xl:grid-cols-11">
        {COLS.map(([k, l]) => (
          <label key={k} className="text-[10px] font-semibold text-slate-400">{l}
            <div data-testid={`veh-new-${k}`}><Cell k={k} v={f[k]} on={(v) => setF((o) => ({ ...o, [k]: v, ...(k === "marka" || k === "model" || k === "arac_tipi" ? { yakit_100km: "" } : {}) }))} /></div>
          </label>
        ))}
        <Button data-testid="vehicle-add" onClick={add} className="mt-3 h-8 bg-blue-600 text-white hover:bg-blue-700"><Plus className="mr-1 h-4 w-4" /> ARAÇ KAYDET</Button>
        <div className="col-span-full text-[10px] text-slate-500">YAKIT BOŞ BIRAKILIRSA MARKA/MODELE GÖRE ORTALAMA TÜKETİM YAZILIR (ÖRN. MERCEDES ACTROS ≈ 29 lt/100 km). İSTERSENİZ DEĞİŞTİREBİLİRSİNİZ.</div>
      </div>
      <div className="overflow-auto rounded-xl border border-slate-800 bg-slate-900">
        <table className="mw-table w-full text-xs">
          <thead className="sticky top-0 z-10 bg-slate-900"><tr className="text-left text-slate-400">{COLS.map(([k, l]) => <th key={k} className="px-2 py-2">{l}</th>)}<th className="px-2 py-2" /></tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} data-testid={`vehicle-row-${r.id}`} className="border-t border-slate-800">
                {COLS.map(([k]) => <td key={k} className="px-1 py-0.5"><Cell k={k} v={r[k]} on={(v) => upd(r.id, k, v)} /></td>)}
                <td className="whitespace-nowrap px-1">
                  {dirty[r.id] && <button data-testid={`vehicle-save-${r.id}`} onClick={() => save(r)} className="mr-1 rounded p-1 text-emerald-400 hover:bg-slate-800"><Save className="h-4 w-4" /></button>}
                  <button data-testid={`vehicle-del-${r.id}`} onClick={() => del(r.id)} className="rounded p-1 text-slate-400 hover:bg-slate-800 hover:text-rose-400"><Trash2 className="h-4 w-4" /></button>
                </td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={11} className="py-10 text-center text-slate-500">HENÜZ ARAÇ YOK</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
